<div class="d-flex w-100">
  <div
    class="box mr-2"
    [ngClass]="{ green: questionNumber == question }"
    *ngFor="let question of questionsArray"
  ></div>
</div>
